/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectPlan from 'modules/me/select-dispatch-plan';
import CurrentDispatchPlanCard from './index/current-plan-card';
import PlanDetailsCard from './index/plan-details-card';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import Notice from 'components/notice';

// new
import AnnotatedSection from 'components/annotated-section';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import BillingDetailsCard from './index/billing-details-card';

/**
 * Style dependencies
 */
import './styles.scss';

const BarcodeLookup = (props) => {
    return (
        <Box>
            <DocumentHead title='Billing - Manage Barcode Lookup Module Plan - Tower Systems' />
            <Topbar title='Barcode Lookup Module Plan' subTitle='Manage your Barcode Lookup Module plan' selected='dispatch'>
            </Topbar>
            <Main padding='xxlarge'>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Subscription Details'
                            description='Barcode Lookup Module plan details.'
                        />
                        <AnnotatedSection.Content>
                            <CurrentDispatchPlanCard />
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
    }),
    {},
)(BarcodeLookup);
